const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaCliente: [], listaTransportadora: [], listaFornecedor: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'USUARIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'USUARIO_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };

        case 'USUARIO_CLIENTE_SELECT_LISTADO':
            return { ...state, listaCliente: action.payload.data };

        case 'USUARIO_TRANSPORTADORA_SELECT_LISTADO':
            return { ...state, listaTransportadora: action.payload.data };

        case 'USUARIO_FORNECEDOR_SELECT_LISTADO':
            return { ...state, listaFornecedor: action.payload.data };

        default:
            return state;
    }
}
